import LoadError from '@/components/ui/LoadError.tsx';
import { tourRoute } from '@/features/dashboard/tours/routes/tourRoute.ts';
import useGetTourDashboardSales from '@/features/dashboard/tours/hooks/useGetTourDashboardSales.ts';
import SignupCurveCard from '@/features/dashboard/tours/components/statistics/SignupCurveCard.tsx';
import SignupFunnelCard from '@/features/dashboard/tours/components/statistics/SignupFunnelCard.tsx';
import BookingSourceCard from '@/features/dashboard/tours/components/statistics/BookingSourceCard.tsx';
import OptionStatsCard from '@/features/dashboard/tours/components/statistics/OptionStatsCard.tsx';
import DemographicsCard from '@/features/dashboard/tours/components/statistics/DemographicsCard.tsx';
import TourStatsTabSkeleton from '@/features/dashboard/tours/pages/TourStatsTabSkeleton.tsx';

/**
 * Statystyki wyjazdu: tempo zapisów, lejek, źródła rezerwacji, opcje i to,
 * kto jedzie. Wykresy dostają całą szerokość, dwa zestawienia stają w parze.
 */
const TourStatsTab = () => {
  const { tourId } = tourRoute.useParams();
  const { data, isPending, isError } = useGetTourDashboardSales(tourId);

  if (isPending) return <TourStatsTabSkeleton />;
  if (isError || !data) return <LoadError subject="statystyk wyjazdu" />;

  return (
    <div className="flex flex-col gap-4">
      <SignupCurveCard signups={data.signups} />
      <SignupFunnelCard funnel={data.funnel} />

      <div className="grid gap-4 lg:grid-cols-2">
        <BookingSourceCard bookingSources={data.bookingSources} />
        <OptionStatsCard
          selections={data.options.selections}
          revenue={data.options.revenue}
        />
      </div>

      <DemographicsCard
        age={data.demographics.age}
        cities={data.demographics.cities}
      />
    </div>
  );
};

export default TourStatsTab;
